const worksList = [
    "Vendedor ambulante",
    "Jalador de clientes",
    "Repartidor de volantes",
    "Ayudante de cocina",
    "Empleado de limpieza",
    "Cajero/a",
    "Mesero/a",
    "Operario de fábrica",
    "Cuidador/a de niños",
    "Cuidador/a de ancianos",
    "Guardia de seguridad",
    "Conductor/a de taxi",
    "Chofer de transporte público",
    "Empacador/a en supermercado",
    "Cajero/a de tienda",
    "Operario/a de producción",
    "Auxiliar de almacén",
    "Cuidador/a de mascotas",
    "Reciclador/a",
    "Manicurista/pedicurista ambulante",
    "Lavador/a de autos",
    "Ayudante de construcción",
    "Pintor/a de brocha gorda",
    "Vendedor/a callejero/a",
    "Lavaplatos",
    "Mensajero/a",
    "Auxiliar de panadería",
    "Ayudante de mecánico",
    "Ayudante de electricista",
    "Cuidador/a de plantas",
    "Guarda de seguridad",
    "Peón de carga",
    "Trabajador/a doméstico/a",
    "Asistente de oficina",
    "Repartidor/a de comida a domicilio",
    "Operador/a de máquinas",
    "Ayudante de albañil",
    "Cuidador/a de jardines",
    "Recogedor/a de basura",
    "Cartero/a",
    "Lavandero/a",
    "Auxiliar de reparto",
    "Estibador/a",
    "Cortador/a de césped",
    "Auxiliar de cocina",
    "Ayudante de peluquería",
    "Trabajador/a de limpieza industrial",
    "Recolector/a de frutas",
    "Operario/a de montaje",
    "Auxiliar de producción",
    "Cargador/a",
    "Operario/a de empaque",
    "Limpiador/a de oficinas",
    "Encargado/a de tareas domésticas",
    "Auxiliar de mantenimiento",
    "Operario/a de fábrica textil",
    "Auxiliar de tienda",
    "Ayudante de logística",
    "Ayudante de almacén",
    "Auxiliar de servicios generales",
    "Operador/a de limpieza industrial",
    "Operador/a de producción de alimentos",
    "Auxiliar de reparto de alimentos",
    "Operario/a de limpieza de edificios",
    "Operario/a de limpieza de hospitales",
    "Operario/a de limpieza de colegios",
    "Operario/a de limpieza de industrias",
    "Operario/a de limpieza de oficinas",
    "Operario/a de limpieza de naves industriales",
    "Operario/a de limpieza de locales comerciales",
    "Operario/a de limpieza de establecimientos hosteleros",
    "Operario/a de limpieza de establecimientos educativos",
    "Operario/a de limpieza de establecimientos sanitarios",
    "Ingeniero Civil",
    "Ingeniero Industrial",
    "Administrador/a de Empresas",
    "Contador/a",
    "Abogado/a",
    "Médico/a",
    "Psicólogo/a",
    "Arquitecto/a",
    "Economista",
    "Educador/a",
];

export default worksList;